import CustomModal from "../CustomModal";

function DisableLocationModal({
  isOpen,
  handleClose,
  location,
  handleDisableLocation,
}) {
  if (!location) return null;
  return (
    <CustomModal isOpen={isOpen} onRequestClose={handleClose} className="delete-modal">
      <div className="inner-member">
        <img
          src={`${process.env.PUBLIC_URL}/images/disable-modal-img.png`}
          alt="Disable location icon"
        />
        <b>
          <p>Are you sure you want to disable this location?</p>
        </b>
        <div className="details-container container">
          <div className="detail">
            <p>Name</p>
            <b>
              <p className="D">{location.name}</p>
            </b>
          </div>
          <div className="detail">
            <p>Location ID</p>
            <b>
              <p className="D">#{location.id}</p>
            </b>
          </div>
          <div className="detail">
            <p>Status</p>
            <b>
              <p className="D">{location.status === "active" ? "Active" : "Inactive"}</p>
            </b>
          </div>
        </div>
        <div className="warning">
          <img
            src={`${process.env.PUBLIC_URL}/images/info-circle.png`}
            alt="Information icon"
          />
          <p>
            Disabling this location will disable all access to associated data, including membership details, attendance records, and any other information linked to this location.
          </p>
        </div>
        <div className="inner-member-btn">
          <button onClick={handleClose}>Cancel</button>
          <button
            style={{ backgroundColor: "#DD9828", color: "#FAFAFA" }}
            onClick={handleDisableLocation}
          >
            Disable Location
          </button>
        </div>
      </div>
    </CustomModal>
  );
}

export default DisableLocationModal;
